/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MemberStatistics } from '../../models/member-statistics';

export interface ProfileStatisticsGet$Params {

/**
 * Number of months to include in statistics (default: 12).
 */
  numberOfMonths?: number;
}

export function profileStatisticsGet(http: HttpClient, rootUrl: string, params?: ProfileStatisticsGet$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<MemberStatistics>> {
  const rb = new RequestBuilder(rootUrl, profileStatisticsGet.PATH, 'get');
  if (params) {
    rb.query('numberOfMonths', params.numberOfMonths, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<MemberStatistics>;
    })
  );
}

profileStatisticsGet.PATH = '/Profile/Statistics';
